import React, { useState } from 'react';
import { Route, Switch, Redirect, NavLink } from 'react-router-dom';
import { MainBodyContainer } from '@sc/custom.styled';
import './SpeakingFeaturesView.css';

import WordGameContainer from './wordgame/WordGameContainer';
import PictionaryContainer from './pictionary/PictionaryContainer';
import WordsInfoContainer from './wordsinfo/WordsInfoContainer';

export default function SpeakingFeaturesView() {
  const [search, setSearch] = useState('');

  return (
    <MainBodyContainer>
      {/* ── Header: tabs (left) + search (right) ── */}
      <div className="speaking-features-header">
        <div className="sf-header-tabs">
          <NavLink
            to="/speaking-features/wordgame"
            className="speaking-features-tab"
            activeClassName="active-tab"
            onClick={() => setSearch('')}
          >
            Word Game
          </NavLink>
          <NavLink
            to="/speaking-features/pictionary"
            className="speaking-features-tab"
            activeClassName="active-tab"
            onClick={() => setSearch('')}
          >
            Pictionary
          </NavLink>
          <NavLink
            to="/speaking-features/wordsinfo"
            className="speaking-features-tab"
            activeClassName="active-tab"
            onClick={() => setSearch('')}
          >
            Words Info
          </NavLink>
        </div>
        <div className="sf-header-search">
          <input
            id="sf-search-input"
            type="text"
            className="sf-search-input"
            placeholder="Search…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/* ── Content area — fixed height, table scrolls ── */}
      <div className="sf-content-area">
        <Switch>
          <Route
            path="/speaking-features/wordgame"
            render={(props) => <WordGameContainer {...props} search={search} />}
          />
          <Route
            path="/speaking-features/pictionary"
            render={(props) => <PictionaryContainer {...props} search={search} />}
          />
          <Route
            path="/speaking-features/wordsinfo"
            render={(props) => <WordsInfoContainer {...props} search={search} />}
          />
          <Redirect to="/speaking-features/wordgame" />
        </Switch>
      </div>
    </MainBodyContainer>
  );
}
